var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import Popover from 'pcln-popover';
import { Flex, IconButton, Text } from 'pcln-design-system';
import { Close, InformationOutline } from 'pcln-icons';
import styled from 'styled-components';
import FocusLock from 'react-focus-lock';
var MontserratText = styled(Text.p)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &&& {\n    // Popover doesn't apply font-family rule to <Text/> in renderContent\n    font-family: 'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  }\n"], ["\n  &&& {\n    // Popover doesn't apply font-family rule to <Text/> in renderContent\n    font-family: 'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  }\n"])));
var AbsolutePosBtn = styled(IconButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &&& {\n    top: 20px;\n    right: 20px;\n    position: absolute;\n  }\n"], ["\n  &&& {\n    top: 20px;\n    right: 20px;\n    position: absolute;\n  }\n"])));
var InfoButton = styled(IconButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  &&& {\n    background-color: transparent;\n    color: inherit;\n    padding: 0;\n  }\n"], ["\n  &&& {\n    background-color: transparent;\n    color: inherit;\n    padding: 0;\n  }\n"
    // z-index should be > that of <Footer />
])));
// z-index should be > that of <Footer />
var Z_INDEX = 2000;
function FooterHintContent(_a) {
    var handleClose = _a.handleClose;
    function stopPropagation(e) {
        e.stopPropagation();
    }
    return (React.createElement(FocusLock, null,
        React.createElement(Flex, { "data-testid": 'footer-hint-content', flexDirection: 'column', p: 2, onClick: stopPropagation },
            React.createElement(MontserratText, { fontSize: 1, mb: 1, mt: 0, fontWeight: 'bold' }, "Tip:"),
            React.createElement(MontserratText, { mt: 0, mb: 1 }, "Use arrow keys to navigate the calendar"),
            React.createElement(AbsolutePosBtn, { onClick: handleClose, title: 'Close tooltip', icon: React.createElement(Close, null) }))));
}
/** @public */
function FooterHint() {
    return (React.createElement(Popover, { renderContent: FooterHintContent, placement: 'top', ariaLabel: 'Calendar navigation tooltip', overlayOpacity: 0.3, width: 350, borderColor: 'borderGray', zIndex: Z_INDEX, idx: 'date-picker-footer' },
        React.createElement(InfoButton, { icon: React.createElement(InformationOutline, { color: 'text.base', size: 20 }), title: 'Navigation tip', type: 'button' })));
}
export default FooterHint;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=FooterHint.js.map